var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,style:(_vm.size ? `width:${_vm.size}px; height:${_vm.size}px;` : ''),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }